export default __webpack_public_path__ + "static/media/promo.4ce9875e.jpg";